import scrollMonitor from 'scrollmonitor';
import {updateHistoryState, appendParamsToURL} from '../helpers/urlUtilities';

/**
 * Grabs the next page number from the provided trigger.
 * @param  {[type]} infiniteTrigger [description]
 * @return {[type]}                 [description]
 */
export function getNextPageNumber(infiniteTrigger) {
    return parseInt(infiniteTrigger.dataset.pageNumber) + 1;
}

/**
 * Update the page's URL with the pagination location the user is in, i.e. "page=1", "page=3", etc.
 * @param  {[type]} nextPageNumber [description]
 * @return {[type]}                [description]
 */
export function updatePageHistory(nextPageNumber) {
    let cgid = document.querySelector('[data-cgid]'),
        urlParams = {page: nextPageNumber};

    //Ensure a category ID is always passed when loading new pages.
    if (cgid) {
        urlParams.cgid = cgid.value;
    }

    updateHistoryState(appendParamsToURL('', urlParams, true));
}

/**
 * Very simple wrapper to leverage scrollMonitor and trigger the next page load.
 */
export function setupInfiniteScroll(infiniteTrigger, pageInsertCallback, distance = 600) {
    let infiniteWatcher = scrollMonitor.create(infiniteTrigger, distance),
        nextPageNumber = getNextPageNumber(infiniteTrigger);

    infiniteWatcher.one('enterViewport', function() {
        //Process page only if trigger element is still available in the DOM.
        if (document.contains(infiniteTrigger)) {
            updatePageHistory(nextPageNumber);

            pageInsertCallback();
        }
    });
}
